import { render, staticRenderFns } from "./appfooter.vue?vue&type=template&id=4a9785c8"
import script from "./appfooter.vue?vue&type=script&lang=js"
export * from "./appfooter.vue?vue&type=script&lang=js"
import style0 from "./appfooter.vue?vue&type=style&index=0&id=4a9785c8&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a9785c8')) {
      api.createRecord('4a9785c8', component.options)
    } else {
      api.reload('4a9785c8', component.options)
    }
    module.hot.accept("./appfooter.vue?vue&type=template&id=4a9785c8", function () {
      api.rerender('4a9785c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/appfooter.vue"
export default component.exports